import { render } from "./ContainerWrapper.vue?vue&type=template&id=0147be73"
const script = {}

import "./ContainerWrapper.vue?vue&type=style&index=0&id=0147be73&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__